// extracted by mini-css-extract-plugin
export default {"container":"KK-z","dimension":"LK-z","dimensionLabels":"MK-z"};